import {
  UPDATE_CURRENT_PRODUCT_ID,
  UPDATE_LOADED_PRODUCTS,
  UPDATE_RECENTLY_SEARCHED_CAROUSEL,
  UPDATE_LOAD_CMS_PLACEMENTS,
  UPDATE_LOAD_FI,
  RESET_FI,
  UPDATE_COLOR_VARIANTS,
  UPDATE_PRODUCT_SIZES,
  UPDATE_ENGRAVING_INFO,
  UPDATE_ENGRAVING_PANEL_VISIBILITY,
  SET_ADD_TO_BAG_ACTIVE,
  SET_ADD_TO_BAG_LOADING,
  SET_ADD_TO_BAG_TEXT,
  SET_VIDEO_PLAYER, UPDATE_FILTERS, UPDATE_FILTER, UPDATE_APPLY_FILTERS, UPDATE_RESET_FILTERS, UPDATE_POLARIZED_FILTER,
} from '../mutations/pdp'

import wcs from '../../libs/wcs/index'
import { Commit } from 'vuex';
import { ProductType, MainProductType, SizeType, } from '../types/pdp.types'
import axiosInstance from '../../../axios-mocks/mock-api/axiosMockApi'
import { isLocalHost } from '../../libs/utils/url'
import axios from 'axios'
import { getCurrentCountry } from '../../libs/utils/currentCountry'
import { getCMSPlacements} from '../../libs/wcs/cms'
import {parseCMSPlacementData } from '../../libs/wcs/pdp-cms-parse'
import { getFindStoresListNormalized } from '../../libs/normalizer'
import { loadProductSizes } from '../../libs/wcs/pdp'
import isEmpty from 'lodash/isEmpty'
import {getAlgoliaProductsByUpcs} from "../../libs/utils/pdp";
import {FinInStoreFilter, getAvailableFilters, initializeFilters} from '@libs/utils/findInStore'
import {fetchMockColorVariants} from '@api/mocks'


export const ACTION_LOAD_CMS_PLACEMENTS = 'ACTION_LOAD_CMS_PLACEMENTS'
export const ACTION_LOAD_PDP = 'ACTION_LOAD_PDP'
export const ACTION_LOAD_PDP_COLOR_VARIANTS = 'ACTION_LOAD_PDP_COLOR_VARIANTS'
export const ACTION_LOAD_RECENTLY_SEARCHED = 'ACTION_LOAD_RECENTLY_SEARCHED'
export const ACTION_LOAD_FIS = 'ACTION_LOAD_FIS'
export const ACTION_RESET_FIS = 'ACTION_RESET_FIS'
export const ACTION_UPDATE_CURRENT_PRODUCT_ID = 'ACTION_UPDATE_CURRENT_PRODUCT_ID'
export const ACTION_UPDATE_LOADED_PRODUCTS = 'ACTION_UPDATE_LOADED_PRODUCTS'
export const ACTION_SAVE_RECENTLY_SEARCHED_SESSION = 'ACTION_SAVE_RECENTLY_SEARCHED_SESSION'
export const ACTION_LOAD_PRODUCT_SIZES = 'ACTION_LOAD_PRODUCT_SIZES'
export const ACTION_UPDATE_ENGRAVING_INFO = 'ACTION_UPDATE_ENGRAVING_INFO'
export const ACTION_UPDATE_ENGRAVING_PANEL_VISIBILITY = 'ACTION_UPDATE_ENGRAVING_PANEL_VISIBILITY'
export const ACTION_GET_ENGRAVING_DATA = 'ACTION_GET_ENGRAVING_DATA'
export const ACTION_TOGGLE_POPUP = 'ACTION_TOGGLE_POPUP'
export const ACTION_SET_ADD_TO_BAG_STATE = 'ACTION_SET_ADD_TO_BAG_STATE'
export const SET_ADD_TO_BAG_LOADING_STATE = 'SET_ADD_TO_BAG_LOADING_STATE'
export const SET_ADD_TO_BAG_TEXT_ACTION = 'SET_ADD_TO_BAG_TEXT'
export const ACTION_SET_VIDEO_PLAYER = 'ACTION_SET_VIDEO_PLAYER'
export const ACTION_UPDATE_FILTER = 'ACTION_UPDATE_FILTER'
export const ACTION_UPDATE_FILTERS = 'ACTION_UPDATE_FILTERS'
export const ACTION_APPLY_FILTERS = 'ACTION_APPLY_FILTERS'
export const ACTION_RESET_FILTERS = 'ACTION_RESET_FILTERS'
export const ACTION_SET_POLARIZED_FILTER = 'ACTION_SET_POLARIZED_FILTER'
const { storeId, langId } = wcs.getStoreConfig()

export const actions = {
  [ACTION_UPDATE_CURRENT_PRODUCT_ID]: function ({ commit }: { commit: Commit }, productId: string) {
    commit(UPDATE_CURRENT_PRODUCT_ID, productId)
  },

  [ACTION_UPDATE_LOADED_PRODUCTS]: async function ({ commit }: { commit: Commit }, productId: string) {
    //switch response mock for local env
    let response = {} as MainProductType

    if (isLocalHost()) {
      response = (await axiosInstance.get(`mock-api/typescript/product/${productId}`)).data.result;
    } else {
      response = (await axios.get(`/wcs/resources/store/${storeId}/products/${productId}?langId=${langId}`)).data
    }
    commit(UPDATE_LOADED_PRODUCTS, response)
    //after UI is updated we can fetch inventory and commit to update inventory availability:
    //todo is not blocking lcp but still may delay what happens inside updateLoadedProducts.then, check if it makes sense to put inventory check inside .then
    try {
      const inventoryResponse = await axios.get(`${response.links.inventory}`);
      response.InventoryAvailability = inventoryResponse.data.InventoryAvailability;
    } catch (error) {
      console.error('Error fetching inventory availability:', error);
      response.InventoryAvailability = [];
    }
    commit(UPDATE_LOADED_PRODUCTS, response)
  },

  [ACTION_LOAD_PDP_COLOR_VARIANTS]: async function ({ commit }: { commit: Commit }, payload:{mainProduct: MainProductType,selectedSize?:string}) {
    //switch response mock for local env
    const {mainProduct,selectedSize} = payload
    let response = {} as any
    const useMockData =false
    if (useMockData) {
      response = await fetchMockColorVariants({
     url:`/mock${mainProduct.links.variants}&langId=${langId}`
      })
    } else {
      try {
        const url = `${mainProduct.links.variants}&langId=${langId}${selectedSize ? `&selectedSize=${selectedSize}` : ''}`
        response = (await axios.get(url)).data
      } catch (error: any) {
        throw new Error('Error fetching product variants', error)
      }
    }

    //if response is empty populate with main product to show one thumb
    if ( isEmpty(response.variants) ) {
      response.variants = [
        {
          "productId": mainProduct.productId,
          "upc": mainProduct.upc,
          "model": mainProduct.model,
          "url": mainProduct.links.url,
          "variantImageUrl": mainProduct.variantImageUrl,
          "variantImageAlt": mainProduct.variantImageAlt,
          "prices": mainProduct.prices,
        },

      ]
    }

    commit(UPDATE_COLOR_VARIANTS, response)
  },
  [ACTION_SET_ADD_TO_BAG_STATE]: function ({ commit }: { commit: Commit }, payload: boolean) {
    commit(SET_ADD_TO_BAG_ACTIVE, payload)
  },

  [ACTION_LOAD_RECENTLY_SEARCHED]: async function ({ commit }: { commit: Commit }, currentProduct: MainProductType) {
    let response = [] as any
    let recentlyViewed = JSON.parse(sessionStorage.getItem('PDP_RECENTLY_VIEWED') || '[]')
    // fetch products from upc and update the state
    let recentlySearchedCarouselProducts = { hits: [] } as any
    recentlySearchedCarouselProducts.hits = [] as ProductType[]


    // Filter out the current product from the recently viewed
    const recentlyViewedFiltered = recentlyViewed.filter((upc: string) => upc !== currentProduct.upc) // list of UPC to fetch wihout the current product

    //avoid showing more than one gift card or egift card:
    let hasGiftCard = false;
    let hasVirtualGiftCard = false;
    if (recentlyViewedFiltered && recentlyViewedFiltered.length > 0) {
      await getAlgoliaProductsByUpcs(recentlyViewedFiltered).then((products) => {
        response = products // response from algolia - array of products
      })
    }

    response.forEach((product: any) => {
      if (product.attributes.PRODUCT_TYPE === "GiftCards") {
        if (product.attributes.MODEL_NAME === 'Gift Card' && !hasGiftCard) {
          recentlySearchedCarouselProducts.hits.push(product);
          hasGiftCard = true;
        } else if (product.attributes.MODEL_NAME === 'Gift Card Digital' && !hasVirtualGiftCard) {
          recentlySearchedCarouselProducts.hits.push(product);
          hasVirtualGiftCard = true;
        }
      } else {
        recentlySearchedCarouselProducts.hits.push(product);
      }
    });
    commit(UPDATE_RECENTLY_SEARCHED_CAROUSEL, recentlySearchedCarouselProducts)
  },


  [ACTION_SAVE_RECENTLY_SEARCHED_SESSION]: async function ({ commit }: { commit: Commit }, currentUpc: string ) {
    let recentlyViewed = JSON.parse(sessionStorage.getItem('PDP_RECENTLY_VIEWED') || '[]')

    // update the recently viewed products upc in the session storage
    if (!recentlyViewed.includes(currentUpc)) {
      recentlyViewed.push(currentUpc)
    } else {
      recentlyViewed = recentlyViewed.filter((upc: string) => upc !== currentUpc)
      recentlyViewed.push(currentUpc)
    }

    // if the recently viewed products exceed 10, remove the first one
    if (recentlyViewed.length > 10) {
      recentlyViewed.shift()
    }
    sessionStorage.setItem('PDP_RECENTLY_VIEWED', JSON.stringify(recentlyViewed))
  },

  [ACTION_LOAD_CMS_PLACEMENTS]: async function ({ commit }: { commit: Commit }, param: any) {
   const name = `pdpPlacements_${param.productId}${window.algoliaConfig.isEarlyAccessParam ? 'EA' : ''}_${getCurrentCountry()}`


    let visitedPlacements = JSON.parse(sessionStorage.getItem('PDP_VISITED_PLACEMENTS') || '[]')
    const existingPlacement = visitedPlacements.find(item => item.name === name)

    let data
    if (existingPlacement) {
      data = existingPlacement.data
    } else {
      data = await getCMSPlacements (param, name)
    }

    // Only parse and commit data if it's new
    if (data) {
      const placements = parseCMSPlacementData(data)


      commit(UPDATE_LOAD_CMS_PLACEMENTS, placements)
    }
    return data
  },
  [ACTION_LOAD_FIS]: async function ({ commit }: { commit: Commit }, position: any = {}) {
    const { storeId, langId } = wcs.getStoreConfig()
    const timeoutValue = Number(sessionStorage.getItem('fisTimeout')) || 5000

    try {
      const formData: any = new FormData()
      formData.append('zipcode', position.location)
      formData.append('zip', position.zip_code)
      formData.append('latitude', position.lat)
      formData.append('longitude', position.lng)
      formData.append('city', position.city)
      formData.append('state', position.initial)
      formData.append('street1', position.location)
      formData.append('partnumbers[]', position.upc)
      formData.append('storeId', storeId)
      formData.append('langId', langId)
      formData.append('parent', '.find-in-store-modal')
      formData.append('searchTarget', 'FIS')
      formData.append('partnumbers', position.upc)

      // Create a timeout promise
      const timeoutPromise = new Promise((resolve, reject) => {
        setTimeout(() => reject(new Error("Request timed out")), timeoutValue);
      });
      // Request promise
      const requestPromise = isLocalHost() ? axiosInstance.get("mock-api/typescript/pdp/store-locator") : axios.post('/AjaxSGHFindPhysicalStoresWithInventoryForProduct', formData);
      // Race between our request and the timeout
      const response = await Promise.race([requestPromise, timeoutPromise]);
      const data = getFindStoresListNormalized(response);
      commit(UPDATE_LOAD_FI, { ...data, location: position.location || '' })
      const {stores} = data
      const payload = !stores?.length ? [] : initializeFilters(getAvailableFilters())
      commit(UPDATE_FILTERS,payload)
      commit(UPDATE_APPLY_FILTERS)
    } catch (error: any) {
      // Here you can handle the timeout specifically if needed
      if (error.message === "Request timed out") {
        commit(RESET_FI)
      }
      throw new Error("Failed load find in store", { cause: error });
    }
  },

  [ACTION_RESET_FIS]: function ({ commit }: { commit: Commit }) {
    commit(RESET_FI)
  },

  [ACTION_LOAD_PRODUCT_SIZES]: async function ({ commit }: { commit: Commit }, productId: string) {
    let productSizes: SizeType[] = await loadProductSizes(productId)
    if (productSizes) commit(UPDATE_PRODUCT_SIZES, productSizes)
  },
  [ACTION_UPDATE_ENGRAVING_INFO]: async function ({ commit }: { commit: Commit }, payload: any) {
    commit(UPDATE_ENGRAVING_INFO, payload)
  },

  [ACTION_UPDATE_ENGRAVING_PANEL_VISIBILITY]: async function ({ commit }: { commit: Commit }, payload: boolean) {
    commit(UPDATE_ENGRAVING_PANEL_VISIBILITY, payload)
  },

  [ACTION_GET_ENGRAVING_DATA]: async function({ commit }: { commit: Commit }, payload: any) {
    //TODO: use action for getting engraving data
  },
  [SET_ADD_TO_BAG_LOADING_STATE]: function ({ commit }: { commit: Commit }, payload: boolean) {
    commit(SET_ADD_TO_BAG_LOADING, payload)
  },
  [SET_ADD_TO_BAG_TEXT_ACTION]: function ({ commit }: { commit: Commit }, payload: string) {
    commit(SET_ADD_TO_BAG_TEXT, payload)
  },
  [ACTION_SET_VIDEO_PLAYER]: function ({ commit }: { commit: Commit }, payload: any) {
    commit(SET_VIDEO_PLAYER, payload)
  },
  [ACTION_UPDATE_FILTER]: function ({ commit }: { commit: Commit }, payload: {
    id: string,
    value: boolean
  }) {
    commit(UPDATE_FILTER, payload)
  },
  [ACTION_UPDATE_FILTERS]: function ({ commit }: { commit: Commit }, payload: FinInStoreFilter[]) {
    commit(UPDATE_FILTERS, payload)
  },
    [ACTION_APPLY_FILTERS]: function ({ commit }: { commit: Commit }) {
  commit(UPDATE_APPLY_FILTERS)
},
  [ACTION_RESET_FILTERS]: function ({ commit }: { commit: Commit }) {
    commit(UPDATE_RESET_FILTERS)
  },
 [ACTION_SET_POLARIZED_FILTER ]: function ({ commit }: { commit: Commit },payload:boolean) {
    commit(UPDATE_POLARIZED_FILTER,payload)
 }
}
